import { FC } from 'react'

import { twMerge } from 'tailwind-merge'

import { Tooltip } from '@/components/ui/tooltip'

import ArrowSendIcon from '../../../icons/arrow-send.svg'
import { IconButton } from '../../components/icon-button'

interface Props {
  onSend: () => void
  disabled: boolean
  disabledReason: string
}

export const ChatSuggestionMessageAction: FC<Props> = ({
  onSend,
  disabled,
  disabledReason,
}) => {
  return (
    <Tooltip
      content={disabledReason || 'Send message'}
      asChild
    >
      <div
        className="flex items-center gap-2.5 border-l border-border p-4 flex-shrink-0 cursor-pointer"
        onClick={onSend}
      >
        <IconButton
          icon={ArrowSendIcon}
          iconClassName={twMerge(
            'h-6 w-6 text-primary-500',
            disabled && 'opacity-50 text-text-default',
          )}
          disabled={disabled}
        />
      </div>
    </Tooltip>
  )
}
